import { ServiceMaker, methods, services } from "../services";
import  Api from '@/services/service-v2'

export const createCoupon = payload =>
    ServiceMaker(`/promo/promotion/create`, methods.POST, services.master, payload);

export const couponCodeList = (payload) =>
ServiceMaker(`promo/promotion/get/user/${payload}`, methods.GET, services.master);

export const editCouponcode = payload =>
ServiceMaker(`/promo/promotion`, methods.PUT, services.master, payload);

export const deleteCouponcode = payload =>
    ServiceMaker(`/promo/promotion`, methods.DELETE, services.master,payload);

export const approveCouponcode = payload =>
    ServiceMaker(`/promo/promotion/approve`, methods.PUT, services.master, payload);

export const listPromotionByFilter = (payload)=> Api().$http.post(`/promo/promotion/list`,payload)
